/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Desuperheater } from "./modelDesuperheater";

class ControllerDesuperheater extends ControllerModel {
  constructor() {
    super("ControllerDesuperheater");
    
    this.setNewNode = (callback) => {
      let _desuperheater = new Desuperheater();
      _desuperheater.decorate(callback);

      this.addNode(_desuperheater);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let _desuperheater = new Desuperheater();
      _desuperheater.copyFrom(node);
      _desuperheater.decorate(callback);
      this.addNode(_desuperheater)
    }

    this.getProperties = async (node) => {
      let n = new Desuperheater();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Desuperheater();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerDesuperheater };
